import { useState } from 'react';
import { Copy, Ellipsis, Eye, Pencil, Trash2 } from 'lucide-react';

import { Button } from 'shadcn/components/ui/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from 'shadcn/components/ui/DropdownMenu';

import DuplicateToAislesDialog from './DuplicateToAislesDialog';

/**
 * Actions for the carousel editor.
 *
 * @param {Object} carousel - The carousel to duplicate.
 * @param {Function} onDelete - Callback function to handle delete.
 * @param {Function} refetchCarousels - Function to refetch carousels.
 * @param {Array} sortedAisles - The list of aisles to duplicate to.
 * @param {Function} toggleView - Callback function to toggle view.
 * @param {string} view - Current view.
 */
export default function CarouselEditorActions({
    carousel,
    onDelete,
    refetchCarousels,
    sortedAisles,
    toggleView,
    view,
}) {
    const [duplicateToAislesDialogOpen, setDuplicateToAislesDialogOpen] = useState(false);

    const handleDelete = () => {
        // eslint-disable-next-line no-alert
        if (window.confirm('Are you sure you want to delete this carousel?')) {
            onDelete();
        }
    };

    return (
        <>
            <div className="flex items-center gap-2">
                <Button variant="ghost" size="icon" onClick={toggleView} type="button">
                    {view === 'summary' ? <Pencil /> : <Eye />}
                </Button>
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button variant="ghost" size="icon" className="data-[state=open]:bg-muted">
                            <Ellipsis />
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end">
                        <DropdownMenuItem onClick={() => setDuplicateToAislesDialogOpen(true)}>
                            <Copy className="mr-2 h-4 w-4" />
                            Duplicate to aisle(s)
                        </DropdownMenuItem>
                        <DropdownMenuSeparator />
                        <DropdownMenuItem variant="destructive" onClick={handleDelete}>
                            <Trash2 className="mr-2 h-4 w-4" />
                            Delete
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </div>

            <DuplicateToAislesDialog
                carousel={carousel}
                isOpen={duplicateToAislesDialogOpen}
                onClose={() => setDuplicateToAislesDialogOpen(false)}
                refetchCarousels={refetchCarousels}
                sortedAisles={sortedAisles}
            />
        </>
    );
}
